export const adminNavLinks = [
  { to: "/admin", label: "Overview", icon: "ri-dashboard-line", end: true },
  { to: "/admin/bookings", label: "Bookings", icon: "ri-calendar-2-line" },
  { to: "/admin/cleaners", label: "Cleaners", icon: "ri-team-line" },
  { to: "/admin/customers", label: "Customers", icon: "ri-user-line" },
  { to: "/admin/payouts", label: "Payouts", icon: "ri-bank-card-2-line" },
  { to: "/admin/settings", label: "Settings", icon: "ri-settings-3-line" },
];

export type AdminKpi = {
  id: string;
  label: string;
  value: string;
  delta: string;
  trend: "up" | "down";
  icon: string;
  tint: string;
  hint: string;
};

export const adminKpis: AdminKpi[] = [
  {
    id: "revenue",
    label: "Revenue this month",
    value: "$48,920",
    delta: "+12.4%",
    trend: "up",
    icon: "ri-money-dollar-circle-line",
    tint: "bg-primary-100 text-primary-700",
    hint: "vs. last month",
  },
  {
    id: "bookings",
    label: "Bookings",
    value: "642",
    delta: "+8.1%",
    trend: "up",
    icon: "ri-calendar-check-line",
    tint: "bg-accent-100 text-accent-700",
    hint: "412 completed · 87 upcoming",
  },
  {
    id: "active",
    label: "Active cleaners",
    value: "38",
    delta: "+3",
    trend: "up",
    icon: "ri-team-line",
    tint: "bg-secondary-100 text-secondary-800",
    hint: "out of 47 on roster",
  },
  {
    id: "rating",
    label: "Avg. rating",
    value: "4.92",
    delta: "-0.02",
    trend: "down",
    icon: "ri-star-line",
    tint: "bg-primary-100 text-primary-700",
    hint: "across 412 reviews",
  },
];

export type RevenuePoint = {
  label: string;
  revenue: number;
  bookings: number;
};

export const revenueSeries: RevenuePoint[] = [
  { label: "Jan", revenue: 28400, bookings: 412 },
  { label: "Feb", revenue: 31200, bookings: 458 },
  { label: "Mar", revenue: 34800, bookings: 502 },
  { label: "Apr", revenue: 36100, bookings: 521 },
  { label: "May", revenue: 41600, bookings: 588 },
  { label: "Jun", revenue: 48920, bookings: 642 },
];

export type AdminBookingRow = {
  id: string;
  customer: string;
  customerAvatar: string;
  service: string;
  cleaner: string;
  time: string;
  date: string;
  address: string;
  amount: number;
  status: "scheduled" | "in_progress" | "completed" | "cancelled" | "pending";
};

export const todaysBookings: AdminBookingRow[] = [
  {
    id: "PN-3041",
    customer: "Eleanor Hayes",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20portrait%20of%20a%20woman%20in%20her%20thirties%20wearing%20cream%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-eleanor&orientation=squarish",
    service: "Standard Clean",
    cleaner: "Maya Olsen",
    time: "9:30 AM",
    date: "Today",
    address: "147 Linden Ave · Brooklyn",
    amount: 174,
    status: "in_progress",
  },
  {
    id: "PN-3042",
    customer: "Marcus Whitfield",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20man%20in%20his%20forties%20warm%20smile%20beige%20shirt%20natural%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-marcus&orientation=squarish",
    service: "Deep Clean",
    cleaner: "Daniel Reyes",
    time: "10:00 AM",
    date: "Today",
    address: "88 Garfield Pl · Park Slope",
    amount: 289,
    status: "scheduled",
  },
  {
    id: "PN-3043",
    customer: "Priya Anand",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20twenties%20gentle%20smile%20sage%20green%20top%20natural%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-priya&orientation=squarish",
    service: "Move-out Clean",
    cleaner: "Aisha Bennett",
    time: "11:30 AM",
    date: "Today",
    address: "412 W 22nd St · Chelsea",
    amount: 348,
    status: "scheduled",
  },
  {
    id: "PN-3044",
    customer: "Theo Lambert",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20young%20man%20warm%20smile%20olive%20shirt%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-theo&orientation=squarish",
    service: "Airbnb Turnover",
    cleaner: "Jonah Park",
    time: "1:00 PM",
    date: "Today",
    address: "29 Bedford Ave · Williamsburg",
    amount: 119,
    status: "scheduled",
  },
  {
    id: "PN-3045",
    customer: "Renata Ozawa",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20thirties%20kind%20smile%20cream%20blouse%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-renata&orientation=squarish",
    service: "Standard Clean",
    cleaner: "Sienna Cole",
    time: "2:30 PM",
    date: "Today",
    address: "5 Hicks St · Brooklyn Heights",
    amount: 169,
    status: "scheduled",
  },
  {
    id: "PN-3046",
    customer: "Devon Maris",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20person%20in%20their%20thirties%20gentle%20smile%20beige%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-devon&orientation=squarish",
    service: "Deep Clean",
    cleaner: "—",
    time: "4:00 PM",
    date: "Today",
    address: "210 Ocean Pkwy · Kensington",
    amount: 314,
    status: "pending",
  },
];

export type AdminCleanerRow = {
  id: string;
  name: string;
  role: string;
  image: string;
  jobsMonth: number;
  rating: number;
  earnings: number;
  status: "active" | "on_leave" | "onboarding";
};

export const topCleaners: AdminCleanerRow[] = [
  {
    id: "maya",
    name: "Maya Olsen",
    role: "Senior Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20olive%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-maya&orientation=squarish",
    jobsMonth: 38,
    rating: 4.97,
    earnings: 3420,
    status: "active",
  },
  {
    id: "aisha",
    name: "Aisha Bennett",
    role: "Eco Clean Lead",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20eco%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-aisha&orientation=squarish",
    jobsMonth: 31,
    rating: 5.0,
    earnings: 3080,
    status: "active",
  },
  {
    id: "daniel",
    name: "Daniel Reyes",
    role: "Deep Clean Specialist",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20man%20cleaner%20warm%20friendly%20smile%20beige%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light&width=200&height=200&seq=admin-top-daniel&orientation=squarish",
    jobsMonth: 28,
    rating: 4.94,
    earnings: 2960,
    status: "active",
  },
  {
    id: "jonah",
    name: "Jonah Park",
    role: "Airbnb Turnover Pro",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20olive%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-jonah&orientation=squarish",
    jobsMonth: 26,
    rating: 4.91,
    earnings: 2540,
    status: "active",
  },
  {
    id: "sienna",
    name: "Sienna Cole",
    role: "Standard Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20clean%20apron%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-sienna&orientation=squarish",
    jobsMonth: 22,
    rating: 4.88,
    earnings: 2110,
    status: "active",
  },
];

export type AdminActivity = {
  id: string;
  icon: string;
  title: string;
  description: string;
  time: string;
  tone: "primary" | "accent" | "secondary" | "danger";
};

export const adminActivity: AdminActivity[] = [
  {
    id: "a1",
    icon: "ri-user-add-line",
    title: "New customer signed up",
    description: "Priya Anand booked her first Deep Clean",
    time: "12 min ago",
    tone: "primary",
  },
  {
    id: "a2",
    icon: "ri-checkbox-circle-line",
    title: "Job completed",
    description: "Maya O. finished PN-3038 · 5-star review",
    time: "38 min ago",
    tone: "accent",
  },
  {
    id: "a3",
    icon: "ri-alert-line",
    title: "Unassigned booking",
    description: "PN-3046 needs a cleaner for 4:00 PM",
    time: "1 hr ago",
    tone: "danger",
  },
  {
    id: "a4",
    icon: "ri-bank-card-line",
    title: "Payout processed",
    description: "$3,420 sent to Maya Olsen",
    time: "2 hr ago",
    tone: "secondary",
  },
  {
    id: "a5",
    icon: "ri-message-3-line",
    title: "Refund requested",
    description: "Theo L. opened a dispute on PN-3019",
    time: "4 hr ago",
    tone: "danger",
  },
  {
    id: "a6",
    icon: "ri-user-heart-line",
    title: "New favorite",
    description: "Eleanor H. added Aisha Bennett",
    time: "Yesterday",
    tone: "primary",
  },
];

export type ServiceMix = {
  label: string;
  share: number;
  tint: string;
};

export const serviceMix: ServiceMix[] = [
  { label: "Standard Clean", share: 46, tint: "bg-primary-500" },
  { label: "Deep Clean", share: 28, tint: "bg-accent-500" },
  { label: "Move-in / Move-out", share: 14, tint: "bg-secondary-500" },
  { label: "Airbnb Turnover", share: 12, tint: "bg-primary-300" },
];

export const cityMix = [
  { label: "Brooklyn", share: 38 },
  { label: "Manhattan", share: 31 },
  { label: "Queens", share: 18 },
  { label: "Bronx", share: 9 },
  { label: "Staten Island", share: 4 },
];

export type AdminBookingFull = {
  id: string;
  customer: string;
  customerAvatar: string;
  customerEmail: string;
  customerPhone: string;
  service: string;
  serviceIcon: string;
  cleanerId: string | null;
  cleanerName: string | null;
  cleanerAvatar: string | null;
  date: string;
  dateLabel: string;
  time: string;
  duration: string;
  address: string;
  city: string;
  bedrooms: number;
  bathrooms: number;
  extras: string[];
  amount: number;
  payment: "paid" | "due" | "refunded";
  status: "scheduled" | "in_progress" | "completed" | "cancelled" | "pending";
  notes: string;
  createdAt: string;
};

export const allAdminBookings: AdminBookingFull[] = [
  {
    id: "PN-3041",
    customer: "Eleanor Hayes",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20portrait%20of%20a%20woman%20in%20her%20thirties%20wearing%20cream%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-eleanor&orientation=squarish",
    customerEmail: "eleanor.h@purenest.co",
    customerPhone: "(347) 555-2018",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-2-line",
    cleanerId: "maya",
    cleanerName: "Maya Olsen",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20olive%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-maya&orientation=squarish",
    date: "2026-06-17",
    dateLabel: "Today",
    time: "9:30 AM",
    duration: "2.5 hrs",
    address: "147 Linden Ave, Apt 4B",
    city: "Brooklyn",
    bedrooms: 2,
    bathrooms: 1,
    extras: ["Inside fridge"],
    amount: 174,
    payment: "paid",
    status: "in_progress",
    notes: "Cat-friendly home. Spare key in the planter.",
    createdAt: "2026-06-10",
  },
  {
    id: "PN-3042",
    customer: "Marcus Whitfield",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20man%20in%20his%20forties%20warm%20smile%20beige%20shirt%20natural%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-marcus&orientation=squarish",
    customerEmail: "marcus.w@studio.co",
    customerPhone: "(917) 555-8821",
    service: "Deep Clean",
    serviceIcon: "ri-sparkling-2-line",
    cleanerId: "daniel",
    cleanerName: "Daniel Reyes",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20man%20cleaner%20warm%20friendly%20smile%20beige%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light&width=200&height=200&seq=admin-top-daniel&orientation=squarish",
    date: "2026-06-17",
    dateLabel: "Today",
    time: "10:00 AM",
    duration: "4 hrs",
    address: "88 Garfield Pl",
    city: "Park Slope",
    bedrooms: 3,
    bathrooms: 2,
    extras: ["Oven", "Windows"],
    amount: 289,
    payment: "paid",
    status: "scheduled",
    notes: "Buzz #2R. Building has elevator.",
    createdAt: "2026-06-08",
  },
  {
    id: "PN-3043",
    customer: "Priya Anand",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20twenties%20gentle%20smile%20sage%20green%20top%20natural%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-priya&orientation=squarish",
    customerEmail: "priya.a@nyu.edu",
    customerPhone: "(646) 555-3320",
    service: "Move-out Clean",
    serviceIcon: "ri-truck-line",
    cleanerId: "aisha",
    cleanerName: "Aisha Bennett",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20eco%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-aisha&orientation=squarish",
    date: "2026-06-17",
    dateLabel: "Today",
    time: "11:30 AM",
    duration: "5 hrs",
    address: "412 W 22nd St, Unit 7",
    city: "Chelsea",
    bedrooms: 2,
    bathrooms: 2,
    extras: ["Inside cabinets", "Wall scuff removal"],
    amount: 348,
    payment: "paid",
    status: "scheduled",
    notes: "Empty unit. Move-out walkthrough at 5 PM.",
    createdAt: "2026-06-05",
  },
  {
    id: "PN-3044",
    customer: "Theo Lambert",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20young%20man%20warm%20smile%20olive%20shirt%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-theo&orientation=squarish",
    customerEmail: "theo@lambertstays.com",
    customerPhone: "(929) 555-1140",
    service: "Airbnb Turnover",
    serviceIcon: "ri-key-2-line",
    cleanerId: "jonah",
    cleanerName: "Jonah Park",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20olive%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-jonah&orientation=squarish",
    date: "2026-06-17",
    dateLabel: "Today",
    time: "1:00 PM",
    duration: "2 hrs",
    address: "29 Bedford Ave",
    city: "Williamsburg",
    bedrooms: 1,
    bathrooms: 1,
    extras: ["Linen refresh"],
    amount: 119,
    payment: "paid",
    status: "scheduled",
    notes: "Lockbox 4421. Guest checks in at 4 PM.",
    createdAt: "2026-06-12",
  },
  {
    id: "PN-3045",
    customer: "Renata Ozawa",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20thirties%20kind%20smile%20cream%20blouse%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-renata&orientation=squarish",
    customerEmail: "renata.o@studio.work",
    customerPhone: "(718) 555-7702",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-2-line",
    cleanerId: "sienna",
    cleanerName: "Sienna Cole",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20clean%20apron%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-sienna&orientation=squarish",
    date: "2026-06-17",
    dateLabel: "Today",
    time: "2:30 PM",
    duration: "2 hrs",
    address: "5 Hicks St, Apt 12C",
    city: "Brooklyn Heights",
    bedrooms: 2,
    bathrooms: 1,
    extras: [],
    amount: 169,
    payment: "due",
    status: "scheduled",
    notes: "Doorman building. Park behind lobby desk.",
    createdAt: "2026-06-09",
  },
  {
    id: "PN-3046",
    customer: "Devon Maris",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20person%20in%20their%20thirties%20gentle%20smile%20beige%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-devon&orientation=squarish",
    customerEmail: "devon.m@gmail.com",
    customerPhone: "(347) 555-9904",
    service: "Deep Clean",
    serviceIcon: "ri-sparkling-2-line",
    cleanerId: null,
    cleanerName: null,
    cleanerAvatar: null,
    date: "2026-06-17",
    dateLabel: "Today",
    time: "4:00 PM",
    duration: "3.5 hrs",
    address: "210 Ocean Pkwy",
    city: "Kensington",
    bedrooms: 3,
    bathrooms: 2,
    extras: ["Inside oven", "Inside fridge"],
    amount: 314,
    payment: "due",
    status: "pending",
    notes: "Customer requested a fragrance-free routine.",
    createdAt: "2026-06-14",
  },
  {
    id: "PN-3047",
    customer: "Camille Rourke",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20with%20red%20hair%20gentle%20smile%20cream%20turtleneck%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-camille&orientation=squarish",
    customerEmail: "camille.r@studio.fm",
    customerPhone: "(212) 555-4421",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-2-line",
    cleanerId: null,
    cleanerName: null,
    cleanerAvatar: null,
    date: "2026-06-18",
    dateLabel: "Tomorrow",
    time: "9:00 AM",
    duration: "2.5 hrs",
    address: "1340 York Ave, Apt 5F",
    city: "Upper East Side",
    bedrooms: 2,
    bathrooms: 2,
    extras: ["Eco products"],
    amount: 184,
    payment: "paid",
    status: "pending",
    notes: "Cat named Tofu. Please keep bedroom door closed.",
    createdAt: "2026-06-15",
  },
  {
    id: "PN-3048",
    customer: "Hugo Bauer",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20bearded%20man%20in%20his%20thirties%20gentle%20smile%20olive%20shirt%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-hugo&orientation=squarish",
    customerEmail: "hugo.b@arch.co",
    customerPhone: "(646) 555-1209",
    service: "Deep Clean",
    serviceIcon: "ri-sparkling-2-line",
    cleanerId: "daniel",
    cleanerName: "Daniel Reyes",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20man%20cleaner%20warm%20friendly%20smile%20beige%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light&width=200&height=200&seq=admin-top-daniel&orientation=squarish",
    date: "2026-06-18",
    dateLabel: "Tomorrow",
    time: "11:00 AM",
    duration: "4 hrs",
    address: "55 Greene St, Loft 3",
    city: "SoHo",
    bedrooms: 2,
    bathrooms: 2,
    extras: ["Windows", "Baseboards"],
    amount: 312,
    payment: "paid",
    status: "scheduled",
    notes: "Loft has exposed brick. Use the soft brush attachment.",
    createdAt: "2026-06-11",
  },
  {
    id: "PN-3049",
    customer: "Beatrice Linn",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20fifties%20gentle%20smile%20cream%20blazer%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-beatrice&orientation=squarish",
    customerEmail: "beatrice.l@home.net",
    customerPhone: "(718) 555-3399",
    service: "Move-in Clean",
    serviceIcon: "ri-truck-line",
    cleanerId: "aisha",
    cleanerName: "Aisha Bennett",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20eco%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-aisha&orientation=squarish",
    date: "2026-06-19",
    dateLabel: "Thu, Jun 19",
    time: "8:30 AM",
    duration: "5 hrs",
    address: "640 Riverside Dr, Apt 9D",
    city: "Morningside Heights",
    bedrooms: 3,
    bathrooms: 2,
    extras: ["Inside cabinets", "Inside oven", "Inside fridge"],
    amount: 392,
    payment: "due",
    status: "scheduled",
    notes: "Customer arrives 1 PM. Please finish kitchen first.",
    createdAt: "2026-06-13",
  },
  {
    id: "PN-3050",
    customer: "Olive Tan",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20woman%20with%20short%20hair%20gentle%20smile%20sage%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-olive&orientation=squarish",
    customerEmail: "olive.t@studio.io",
    customerPhone: "(929) 555-7711",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-2-line",
    cleanerId: null,
    cleanerName: null,
    cleanerAvatar: null,
    date: "2026-06-19",
    dateLabel: "Thu, Jun 19",
    time: "1:30 PM",
    duration: "2 hrs",
    address: "118 N 6th St, Apt 2",
    city: "Williamsburg",
    bedrooms: 1,
    bathrooms: 1,
    extras: [],
    amount: 134,
    payment: "paid",
    status: "pending",
    notes: "Friendly dog (Beagle). Will be crated.",
    createdAt: "2026-06-15",
  },
  {
    id: "PN-3038",
    customer: "Lana Petrov",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20forties%20gentle%20smile%20beige%20blouse%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-lana&orientation=squarish",
    customerEmail: "lana.p@gmail.com",
    customerPhone: "(347) 555-2266",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-2-line",
    cleanerId: "maya",
    cleanerName: "Maya Olsen",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20olive%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-maya&orientation=squarish",
    date: "2026-06-16",
    dateLabel: "Yesterday",
    time: "10:00 AM",
    duration: "2.5 hrs",
    address: "92 Carroll St",
    city: "Carroll Gardens",
    bedrooms: 2,
    bathrooms: 1,
    extras: [],
    amount: 172,
    payment: "paid",
    status: "completed",
    notes: "Repeat customer · 5-star review",
    createdAt: "2026-06-02",
  },
  {
    id: "PN-3037",
    customer: "Sebastian Cole",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20man%20gentle%20smile%20cream%20henley%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-sebastian&orientation=squarish",
    customerEmail: "seb.cole@studio.app",
    customerPhone: "(212) 555-9120",
    service: "Deep Clean",
    serviceIcon: "ri-sparkling-2-line",
    cleanerId: "jonah",
    cleanerName: "Jonah Park",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20olive%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-jonah&orientation=squarish",
    date: "2026-06-15",
    dateLabel: "Sun, Jun 15",
    time: "9:00 AM",
    duration: "4 hrs",
    address: "414 E 9th St, Apt 5",
    city: "East Village",
    bedrooms: 2,
    bathrooms: 1,
    extras: ["Inside fridge"],
    amount: 298,
    payment: "paid",
    status: "completed",
    notes: "",
    createdAt: "2026-06-04",
  },
  {
    id: "PN-3036",
    customer: "Mira Halloran",
    customerAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20with%20curly%20hair%20gentle%20smile%20olive%20top%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-mira&orientation=squarish",
    customerEmail: "mira.h@design.co",
    customerPhone: "(917) 555-5588",
    service: "Standard Clean",
    serviceIcon: "ri-home-smile-2-line",
    cleanerId: "sienna",
    cleanerName: "Sienna Cole",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20clean%20apron%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-sienna&orientation=squarish",
    date: "2026-06-14",
    dateLabel: "Sat, Jun 14",
    time: "11:00 AM",
    duration: "2 hrs",
    address: "73 Underhill Ave",
    city: "Prospect Heights",
    bedrooms: 1,
    bathrooms: 1,
    extras: [],
    amount: 142,
    payment: "refunded",
    status: "cancelled",
    notes: "Cancelled by customer 2 hrs before. Refunded in full.",
    createdAt: "2026-06-08",
  },
];

export type AvailableCleaner = {
  id: string;
  name: string;
  role: string;
  image: string;
  rating: number;
  jobsThisWeek: number;
  distance: string;
  availability: "available" | "busy" | "off";
  nextSlot: string;
  specialties: string[];
};

export const availableCleaners: AvailableCleaner[] = [
  {
    id: "maya",
    name: "Maya Olsen",
    role: "Senior Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20olive%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-maya&orientation=squarish",
    rating: 4.97,
    jobsThisWeek: 9,
    distance: "1.2 mi away",
    availability: "available",
    nextSlot: "Free after 12:30 PM",
    specialties: ["Standard", "Deep", "Pet-friendly"],
  },
  {
    id: "aisha",
    name: "Aisha Bennett",
    role: "Eco Clean Lead",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20eco%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-aisha&orientation=squarish",
    rating: 5.0,
    jobsThisWeek: 8,
    distance: "2.6 mi away",
    availability: "available",
    nextSlot: "Free after 2:00 PM",
    specialties: ["Eco", "Move-in / Move-out"],
  },
  {
    id: "daniel",
    name: "Daniel Reyes",
    role: "Deep Clean Specialist",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20man%20cleaner%20warm%20friendly%20smile%20beige%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light&width=200&height=200&seq=admin-top-daniel&orientation=squarish",
    rating: 4.94,
    jobsThisWeek: 7,
    distance: "3.4 mi away",
    availability: "busy",
    nextSlot: "Busy until 3:00 PM",
    specialties: ["Deep", "Post-construction"],
  },
  {
    id: "jonah",
    name: "Jonah Park",
    role: "Airbnb Turnover Pro",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20olive%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-jonah&orientation=squarish",
    rating: 4.91,
    jobsThisWeek: 11,
    distance: "0.8 mi away",
    availability: "available",
    nextSlot: "Free after 3:30 PM",
    specialties: ["Airbnb", "Linen refresh"],
  },
  {
    id: "sienna",
    name: "Sienna Cole",
    role: "Standard Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20clean%20apron%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-sienna&orientation=squarish",
    rating: 4.88,
    jobsThisWeek: 6,
    distance: "4.1 mi away",
    availability: "available",
    nextSlot: "Free all afternoon",
    specialties: ["Standard", "Recurring"],
  },
  {
    id: "noor",
    name: "Noor Halabi",
    role: "Senior Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20sage%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-noor&orientation=squarish",
    rating: 4.96,
    jobsThisWeek: 5,
    distance: "2.0 mi away",
    availability: "available",
    nextSlot: "Free after 11:00 AM",
    specialties: ["Standard", "Deep", "Eco"],
  },
  {
    id: "rafa",
    name: "Rafael Cruz",
    role: "Deep Clean Pro",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20cream%20apron%20clean%20beige%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-rafa&orientation=squarish",
    rating: 4.89,
    jobsThisWeek: 4,
    distance: "5.6 mi away",
    availability: "off",
    nextSlot: "Off until Thursday",
    specialties: ["Deep", "Move-out"],
  },
];

export type AdminPayout = {
  id: string;
  cleanerId: string;
  cleanerName: string;
  cleanerRole: string;
  cleanerAvatar: string;
  period: string;
  periodLabel: string;
  jobs: number;
  gross: number;
  fees: number;
  net: number;
  method: "ACH" | "Instant" | "Check";
  account: string;
  status: "paid" | "pending" | "processing" | "failed";
  scheduledFor: string;
  paidAt: string | null;
};

export const adminPayouts: AdminPayout[] = [
  {
    id: "PO-7042",
    cleanerId: "maya",
    cleanerName: "Maya Olsen",
    cleanerRole: "Senior Cleaner",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20olive%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-maya&orientation=squarish",
    period: "2026-06-09__2026-06-15",
    periodLabel: "Jun 9 – Jun 15",
    jobs: 11,
    gross: 1820,
    fees: 64,
    net: 1756,
    method: "ACH",
    account: "Chase ••4421",
    status: "paid",
    scheduledFor: "Jun 17",
    paidAt: "Jun 17, 9:12 AM",
  },
  {
    id: "PO-7041",
    cleanerId: "aisha",
    cleanerName: "Aisha Bennett",
    cleanerRole: "Eco Clean Lead",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20eco%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-aisha&orientation=squarish",
    period: "2026-06-09__2026-06-15",
    periodLabel: "Jun 9 – Jun 15",
    jobs: 9,
    gross: 1548,
    fees: 52,
    net: 1496,
    method: "Instant",
    account: "Wells ••8801",
    status: "processing",
    scheduledFor: "Jun 17",
    paidAt: null,
  },
  {
    id: "PO-7040",
    cleanerId: "daniel",
    cleanerName: "Daniel Reyes",
    cleanerRole: "Deep Clean Specialist",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20man%20cleaner%20warm%20friendly%20smile%20beige%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light&width=200&height=200&seq=admin-top-daniel&orientation=squarish",
    period: "2026-06-09__2026-06-15",
    periodLabel: "Jun 9 – Jun 15",
    jobs: 8,
    gross: 1672,
    fees: 58,
    net: 1614,
    method: "ACH",
    account: "BofA ••1903",
    status: "pending",
    scheduledFor: "Jun 18",
    paidAt: null,
  },
  {
    id: "PO-7039",
    cleanerId: "jonah",
    cleanerName: "Jonah Park",
    cleanerRole: "Airbnb Turnover Pro",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20olive%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-jonah&orientation=squarish",
    period: "2026-06-09__2026-06-15",
    periodLabel: "Jun 9 – Jun 15",
    jobs: 12,
    gross: 1428,
    fees: 48,
    net: 1380,
    method: "ACH",
    account: "Citi ••5520",
    status: "pending",
    scheduledFor: "Jun 18",
    paidAt: null,
  },
  {
    id: "PO-7038",
    cleanerId: "sienna",
    cleanerName: "Sienna Cole",
    cleanerRole: "Standard Cleaner",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20clean%20apron%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-sienna&orientation=squarish",
    period: "2026-06-09__2026-06-15",
    periodLabel: "Jun 9 – Jun 15",
    jobs: 7,
    gross: 1148,
    fees: 38,
    net: 1110,
    method: "ACH",
    account: "Chase ••2218",
    status: "failed",
    scheduledFor: "Jun 17",
    paidAt: null,
  },
  {
    id: "PO-7037",
    cleanerId: "noor",
    cleanerName: "Noor Halabi",
    cleanerRole: "Senior Cleaner",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20sage%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-noor&orientation=squarish",
    period: "2026-06-02__2026-06-08",
    periodLabel: "Jun 2 – Jun 8",
    jobs: 6,
    gross: 1042,
    fees: 34,
    net: 1008,
    method: "ACH",
    account: "Capital One ••6610",
    status: "paid",
    scheduledFor: "Jun 10",
    paidAt: "Jun 10, 8:47 AM",
  },
  {
    id: "PO-7036",
    cleanerId: "marco",
    cleanerName: "Marco Bellini",
    cleanerRole: "Standard Cleaner",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20beige%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-marco&orientation=squarish",
    period: "2026-06-02__2026-06-08",
    periodLabel: "Jun 2 – Jun 8",
    jobs: 8,
    gross: 1248,
    fees: 42,
    net: 1206,
    method: "ACH",
    account: "Chase ••7740",
    status: "paid",
    scheduledFor: "Jun 10",
    paidAt: "Jun 10, 9:01 AM",
  },
  {
    id: "PO-7035",
    cleanerId: "yuki",
    cleanerName: "Yuki Tanaka",
    cleanerRole: "Eco Cleaner",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-yuki&orientation=squarish",
    period: "2026-06-02__2026-06-08",
    periodLabel: "Jun 2 – Jun 8",
    jobs: 5,
    gross: 920,
    fees: 30,
    net: 890,
    method: "Instant",
    account: "Wells ••3304",
    status: "paid",
    scheduledFor: "Jun 10",
    paidAt: "Jun 10, 9:14 AM",
  },
  {
    id: "PO-7034",
    cleanerId: "lina",
    cleanerName: "Lina Park",
    cleanerRole: "Standard Cleaner",
    cleanerAvatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20cream%20apron%20clean%20beige%20background%20editorial%20natural%20soft%20light%20approachable%20short%20hair&width=200&height=200&seq=admin-cleaner-lina&orientation=squarish",
    period: "2026-06-02__2026-06-08",
    periodLabel: "Jun 2 – Jun 8",
    jobs: 6,
    gross: 968,
    fees: 32,
    net: 936,
    method: "Check",
    account: "Mailed check",
    status: "paid",
    scheduledFor: "Jun 10",
    paidAt: "Jun 11, 4:20 PM",
  },
];

export type AdminCustomer = {
  id: string;
  name: string;
  email: string;
  avatar: string;
  city: string;
  status: "active" | "new" | "churned";
  bookings: number;
  lifetime: number;
  lastBooking: string;
  plan: "One-time" | "Weekly" | "Bi-weekly" | "Monthly";
};

export const adminCustomers: AdminCustomer[] = [
  {
    id: "eleanor",
    name: "Eleanor Hayes",
    email: "eleanor.h@purenest.co",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20portrait%20of%20a%20woman%20in%20her%20thirties%20wearing%20cream%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-eleanor&orientation=squarish",
    city: "Brooklyn",
    status: "active",
    bookings: 14,
    lifetime: 2436,
    lastBooking: "Today",
    plan: "Bi-weekly",
  },
  {
    id: "marcus",
    name: "Marcus Whitfield",
    email: "marcus.w@studio.co",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20man%20in%20his%20forties%20warm%20smile%20beige%20shirt%20natural%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-marcus&orientation=squarish",
    city: "Park Slope",
    status: "active",
    bookings: 9,
    lifetime: 1842,
    lastBooking: "Today",
    plan: "Monthly",
  },
  {
    id: "priya",
    name: "Priya Anand",
    email: "priya.a@nyu.edu",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20twenties%20gentle%20smile%20sage%20green%20top%20natural%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-priya&orientation=squarish",
    city: "Chelsea",
    status: "new",
    bookings: 1,
    lifetime: 348,
    lastBooking: "Today",
    plan: "One-time",
  },
  {
    id: "theo",
    name: "Theo Lambert",
    email: "theo@lambertstays.com",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20young%20man%20warm%20smile%20olive%20shirt%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-theo&orientation=squarish",
    city: "Williamsburg",
    status: "active",
    bookings: 22,
    lifetime: 2618,
    lastBooking: "Today",
    plan: "Weekly",
  },
  {
    id: "renata",
    name: "Renata Ozawa",
    email: "renata.o@studio.work",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20thirties%20kind%20smile%20cream%20blouse%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-renata&orientation=squarish",
    city: "Brooklyn Heights",
    status: "active",
    bookings: 11,
    lifetime: 1858,
    lastBooking: "Today",
    plan: "Bi-weekly",
  },
  {
    id: "devon",
    name: "Devon Maris",
    email: "devon.m@gmail.com",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20person%20in%20their%20thirties%20gentle%20smile%20beige%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-devon&orientation=squarish",
    city: "Kensington",
    status: "new",
    bookings: 1,
    lifetime: 314,
    lastBooking: "Today",
    plan: "One-time",
  },
  {
    id: "camille",
    name: "Camille Rourke",
    email: "camille.r@studio.fm",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20with%20red%20hair%20gentle%20smile%20cream%20turtleneck%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-camille&orientation=squarish",
    city: "Upper East Side",
    status: "active",
    bookings: 7,
    lifetime: 1284,
    lastBooking: "Tomorrow",
    plan: "Monthly",
  },
  {
    id: "hugo",
    name: "Hugo Bauer",
    email: "hugo.b@arch.co",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20bearded%20man%20in%20his%20thirties%20gentle%20smile%20olive%20shirt%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-hugo&orientation=squarish",
    city: "SoHo",
    status: "active",
    bookings: 18,
    lifetime: 3120,
    lastBooking: "Tomorrow",
    plan: "Weekly",
  },
  {
    id: "beatrice",
    name: "Beatrice Linn",
    email: "beatrice.l@home.net",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20fifties%20gentle%20smile%20cream%20blazer%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-beatrice&orientation=squarish",
    city: "Morningside Heights",
    status: "active",
    bookings: 5,
    lifetime: 1170,
    lastBooking: "Thu, Jun 19",
    plan: "Monthly",
  },
  {
    id: "olive",
    name: "Olive Tan",
    email: "olive.t@studio.io",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20woman%20with%20short%20hair%20gentle%20smile%20sage%20sweater%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-olive&orientation=squarish",
    city: "Williamsburg",
    status: "new",
    bookings: 1,
    lifetime: 134,
    lastBooking: "Thu, Jun 19",
    plan: "One-time",
  },
  {
    id: "lana",
    name: "Lana Petrov",
    email: "lana.p@gmail.com",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20in%20her%20forties%20gentle%20smile%20beige%20blouse%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-lana&orientation=squarish",
    city: "Carroll Gardens",
    status: "active",
    bookings: 24,
    lifetime: 4128,
    lastBooking: "Yesterday",
    plan: "Weekly",
  },
  {
    id: "sebastian",
    name: "Sebastian Cole",
    email: "seb.cole@studio.app",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20man%20gentle%20smile%20cream%20henley%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-sebastian&orientation=squarish",
    city: "East Village",
    status: "active",
    bookings: 12,
    lifetime: 2284,
    lastBooking: "Sun, Jun 15",
    plan: "Bi-weekly",
  },
  {
    id: "mira",
    name: "Mira Halloran",
    email: "mira.h@design.co",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20woman%20with%20curly%20hair%20gentle%20smile%20olive%20top%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-mira&orientation=squarish",
    city: "Prospect Heights",
    status: "churned",
    bookings: 3,
    lifetime: 426,
    lastBooking: "Apr 14",
    plan: "One-time",
  },
  {
    id: "ben",
    name: "Ben Kowalski",
    email: "ben.k@home.io",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20man%20in%20his%20thirties%20gentle%20smile%20olive%20sweater%20glasses%20natural%20soft%20studio%20light%20editorial%20photography%20approachable%20clean%20background&width=120&height=120&seq=admin-cust-ben&orientation=squarish",
    city: "Astoria",
    status: "churned",
    bookings: 2,
    lifetime: 298,
    lastBooking: "Mar 02",
    plan: "One-time",
  },
];

export type AdminCleaner = {
  id: string;
  name: string;
  role: string;
  image: string;
  status: "active" | "onboarding" | "on_leave";
  jobs: number;
  rating: number;
  city: string;
};

export const adminCleanersRoster: AdminCleaner[] = [
  {
    id: "maya",
    name: "Maya Olsen",
    role: "Senior Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20olive%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-maya&orientation=squarish",
    status: "active",
    jobs: 38,
    rating: 4.97,
    city: "Brooklyn",
  },
  {
    id: "aisha",
    name: "Aisha Bennett",
    role: "Eco Clean Lead",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20eco%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-aisha&orientation=squarish",
    status: "active",
    jobs: 31,
    rating: 5.0,
    city: "Manhattan",
  },
  {
    id: "daniel",
    name: "Daniel Reyes",
    role: "Deep Clean Specialist",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20man%20cleaner%20warm%20friendly%20smile%20beige%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light&width=200&height=200&seq=admin-top-daniel&orientation=squarish",
    status: "active",
    jobs: 28,
    rating: 4.94,
    city: "Brooklyn",
  },
  {
    id: "jonah",
    name: "Jonah Park",
    role: "Airbnb Turnover Pro",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20olive%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-jonah&orientation=squarish",
    status: "active",
    jobs: 26,
    rating: 4.91,
    city: "Manhattan",
  },
  {
    id: "sienna",
    name: "Sienna Cole",
    role: "Standard Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20clean%20apron%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-top-sienna&orientation=squarish",
    status: "active",
    jobs: 22,
    rating: 4.88,
    city: "Brooklyn",
  },
  {
    id: "noor",
    name: "Noor Halabi",
    role: "Senior Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20sage%20uniform%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-noor&orientation=squarish",
    status: "active",
    jobs: 19,
    rating: 4.96,
    city: "Queens",
  },
  {
    id: "rafa",
    name: "Rafael Cruz",
    role: "Deep Clean Pro",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20cream%20apron%20clean%20beige%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-rafa&orientation=squarish",
    status: "on_leave",
    jobs: 14,
    rating: 4.89,
    city: "Brooklyn",
  },
  {
    id: "lina",
    name: "Lina Park",
    role: "Standard Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20woman%20cleaner%20warm%20smile%20cream%20apron%20clean%20beige%20background%20editorial%20natural%20soft%20light%20approachable%20short%20hair&width=200&height=200&seq=admin-cleaner-lina&orientation=squarish",
    status: "active",
    jobs: 17,
    rating: 4.85,
    city: "Brooklyn",
  },
  {
    id: "theo",
    name: "Theo Larsen",
    role: "Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20man%20cleaner%20warm%20smile%20cream%20apron%20clean%20beige%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-theo&orientation=squarish",
    status: "onboarding",
    jobs: 0,
    rating: 0,
    city: "Manhattan",
  },
  {
    id: "ivy",
    name: "Ivy Chen",
    role: "Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20olive%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-ivy&orientation=squarish",
    status: "onboarding",
    jobs: 0,
    rating: 0,
    city: "Queens",
  },
  {
    id: "marco",
    name: "Marco Bellini",
    role: "Standard Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20man%20cleaner%20warm%20smile%20beige%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-marco&orientation=squarish",
    status: "active",
    jobs: 21,
    rating: 4.83,
    city: "Queens",
  },
  {
    id: "yuki",
    name: "Yuki Tanaka",
    role: "Eco Cleaner",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20friendly%20young%20woman%20cleaner%20warm%20smile%20sage%20apron%20clean%20cream%20background%20editorial%20natural%20soft%20light%20approachable&width=200&height=200&seq=admin-cleaner-yuki&orientation=squarish",
    status: "active",
    jobs: 15,
    rating: 4.9,
    city: "Manhattan",
  },
];